import { MEDIA_ITEMS_OPTION, USER_CAN_SELECT_PRODUCTS_FROM_LIST } from '../../fields'
import { MEDIA_PRODUCTS } from '../../../../fields'

export const getShowMediaDeliveryDatesQuestion = values => {
  const userCanSelectProductsFromList = values[USER_CAN_SELECT_PRODUCTS_FROM_LIST]
  const isMediaProductsOptionSelected = values[MEDIA_ITEMS_OPTION] === MEDIA_PRODUCTS

  return isMediaProductsOptionSelected && !userCanSelectProductsFromList
}
